class DivToggle{
    constructor(){
        this.ToggleTriggers = document.querySelectorAll(".collapse-trigger")
        this.ToggleClosers = document.querySelectorAll(".collapse-close-button")

        //this.divTogglerId = this.divTogglerTrigger.getAttribute('data-id');
        //this.divTogglerTrigger.addEventListener("click", this.toggleDiv( this.divTogglerId ))

        this.ToggleTriggers.forEach(ToggleTrigger => {
            //divTogglerTrigger.addEventListener('click', this.toggleDiv )
            ToggleTrigger.addEventListener('click', event => {
                this.toggleDiv( event.target.getAttribute('data-collapse-target'))
            });
        });

        this.ToggleClosers.forEach(ToggleCloser => {
            //divTogglerbutton.addEventListener('click', this.toggleDiv )
            ToggleCloser.addEventListener('click', event => {
                this.closeDiv( event.target.getAttribute('data-collapse-target'))
            });
        });
    }

    toggleDiv( dataId) {
        //dataId = this.divTogglerTrigger.getAttribute('data-id')
        //dataId = this.event.target.getAttribute('data-id')
        //divToToggle = document.body.querySelector('div[data-id='+dataId+']');
        let ToggleDiv = document.getElementById('div-collapse-'+dataId);
        //alert(ToggleDiv);
       
        ToggleDiv.classList.toggle('absolute')
        ToggleDiv.classList.toggle('hidden')
        //let CloseDivButton = document.querySelector('button[data-close="'+dataId+'"]');
        //CloseDivButton.addEventListener('click', this.closeDiv( dataId ))
    }

    closeDiv( dataId) {
        //dataId = this.divTogglerTrigger.getAttribute('data-id')
        //newToggleDiv = document.getElementById(dataId);
        //divToToggle = document.body.querySelector('div[data-id='+dataId+']');
        let ToggleDiv = document.getElementById('div-collapse-'+dataId);
        //alert(document.querySelector('[data-id="'+ dataId +'"]'));
        
        ToggleDiv.classList.remove('absolute')
        ToggleDiv.classList.add('hidden')
    }
}
export default DivToggle